<template>
  <div
    class="orangehrm-upgrade-container"
    style="display: none !important"
  ></div>
</template>

<script>
export default {
  name: 'UpgradeButton',
};
</script>

<style scoped lang="scss">
.orangehrm-upgrade-container {
  display: none !important;
}
</style>
